"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _getDisplayBytes = _interopRequireDefault(require("@devsta/get-display-bytes"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./styles/_asset-carousel-item.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function getAssetMeta(metaDataString) {
  try {
    var _JSON$parse = JSON.parse(metaDataString),
        type = _JSON$parse.type,
        size = _JSON$parse.size;

    return "".concat(type.split('/')[1], " | ").concat((0, _getDisplayBytes.default)(size));
  } catch (e) {
    return '';
  }
}

function AssetsCarouselItem(_ref) {
  var asset = _ref.asset;

  var _ref2 = asset || {},
      _ref2$metaData = _ref2.metaData,
      metaData = _ref2$metaData === void 0 ? '' : _ref2$metaData,
      title = _ref2.title;

  return (/*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('asset-carousel-item', {
        'asset-carousel-item--empty': !asset
      })
    }, /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
      asset: asset,
      height: "200px",
      canPlayVideo: true
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "asset-carousel-item__title"
    }, title), /*#__PURE__*/_react.default.createElement("p", {
      className: "asset-carousel-item__meta"
    }, getAssetMeta(metaData)))
  );
}

var _default = (0, _react.memo)(AssetsCarouselItem);

exports.default = _default;